/**
 * Títulos disponíveis na aplicação.
 */
export enum PageTitles {
  MOST_CARD_PROTECTED = 'Cartão + Protegido',
  MANUAL = 'Manual do produto',
  TERMS = 'Termos e condições',
}
